import _get from 'lodash.get';
import { replaceBucketKeysWithUrlsInArray } from '@shootsta/client-aws-s3';

async function resolveProfileImages(
  videos: Video[],
  apiClient: any
): Promise<Video[]> {
  if (!videos.length) {
    return videos;
  }

  try {
    return replaceBucketKeysWithUrlsInArray({
      apiClient,
      dataArray: videos.map((video) => ({
        ...video,
        organisationId: video.organisationId
      })),
      substitutedKeys: [
        { key: 'video', subKeys: [{ key: 'creator', subKeys: ['imageUrl'] }] }
      ]
    });
  } catch (e: any) {
    return videos.map((video) => {
      const creator = _get(video, 'creator', {});

      return {
        organisationId: video.organisationId,
        ...video,
        creator: {
          ...creator,
          imageUrl: void 0
        }
      };
    });
  }
}

export default resolveProfileImages;
